import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";

const TablaA = () => {
  useEffect(() => {
    document.title = "Tabla A";
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Tabla de Aplicabilidad" },
        ]}
      />

      <TitlePages
        title="Transparencia"
        subTitle="Ley de Transparencia y Acceso a la Información Pública del Estado de Tlaxcala."
      />

      <h5 className="text-center text-strong">
        Tabla de aplicabilidad de Obligaciones de Transparencia
      </h5>

      <div className="w-100 mt-5 Grid__folder">
        <div className="margin-bottom-1">
          <Link to="/TablaA2026">
            <img
              className="img-fluid"
              src="https://itetlax.org.mx/assets/img/icons/2026.png"
              alt="Tabla de Aplicabilidad (2026)"
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default TablaA;